export function getApiErrorReferenceText(requestId: string, sentryEventId?: unknown): string {
  const lines = [`Request ID: ${requestId}`]
  if(typeof sentryEventId === 'string' && sentryEventId) {
    lines.push(`Sentry event ID: ${sentryEventId}`)
  }
  return lines.join('\n')
}
